const PlataformaLayout = resolve => {
    require.ensure(["./../layouts/PlataformaLayout.vue"], () => {
        resolve(require("./../layouts/PlataformaLayout.vue"));
    });
};
const Plataforma = resolve => {
    require.ensure(["./../components/Inicio/Plataforma.vue"], () => {
      resolve(require("./../components/Inicio/Plataforma.vue"));
    });
};

const MultasAdministrativasInicio = resolve => { 
    require.ensure(['./../components/MultasAdministrativas/Inicio.vue'], ()=>{ 
        resolve(require('./../components/MultasAdministrativas/Inicio.vue')); 
    }); 
};

const MultasAdminsitrativasEstadoCuenta = resolve => { 
    require.ensure(['./../components/MultasAdministrativas/EstadoCuenta.vue'], ()=>{ 
        resolve(require('./../components/MultasAdministrativas/EstadoCuenta.vue')); 
    }); 
};

export const routesMultasAdministrativas = [
    {
        path: "/",
        component: PlataformaLayout,
        children: [
            {
                path : '/multas-administrativas', 
                name: 'pageMultasAdministrativas', 
                component: MultasAdministrativasInicio, 
                meta:{ 
                    breadCrumb: [
                        {
                            name: 'Plataforma', 
                            link:'/'
                        },
                        {
                            name:'Multas Administrativas', 
                            link:''
                        }
                    ]
                }
            },
            {
                path : '/multas-administrativas/estado-cuenta', 
                name: 'pageMultasAdministrativasEstadoCuenta', 
                component: MultasAdminsitrativasEstadoCuenta, 
                meta:{ 
                    breadCrumb: [
                        {
                            name: 'Plataforma', 
                            link:'/'
                        },
                        {
                            name:'Multas Administrativas', 
                            link:''
                        },
                        {
                            name:'Estado de Cuenta', 
                            link:''
                        }
                    ]
                }
            }
        ]
    }

    
];


// WEBPACK FOOTER //
// ./src/router/routesMultasAdministrativas.js